import { render, staticRenderFns } from "./review-comment-modal.vue?vue&type=template&id=f6a2499a"
import script from "./review-comment-modal.vue?vue&type=script&lang=js"
export * from "./review-comment-modal.vue?vue&type=script&lang=js"
import style0 from "./review-comment-modal.vue?vue&type=style&index=0&id=f6a2499a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VTextField: require('/app/node_modules/vuetify/lib/components/VTextField/VTextField.js').default,VTextarea: require('/app/node_modules/vuetify/lib/components/VTextarea/VTextarea.js').default,VForm: require('/app/node_modules/vuetify/lib/components/VForm/VForm.js').default,VSpacer: require('/app/node_modules/vuetify/lib/components/VGrid/VSpacer.js').default,VCard: require('/app/node_modules/vuetify/lib/components/VCard/VCard.js').default,VDialog: require('/app/node_modules/vuetify/lib/components/VDialog/VDialog.js').default})


/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VForm,VIcon,VSpacer,VTextField,VTextarea})
